import React, { useEffect } from "react";
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from "react-router";
import { clearListInfoAction } from 'redux/actions'
// import { listAddAction } from 'redux/actions';
// import DebtInformationForm from '../../DebtInformation/components/forms/DebtInformationForm'

const AddDebtInformationView = ({ t, i18n, setIsError }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    // const [validateForm, setValidateForm] = useState()

    useEffect(() => {
        dispatch(clearListInfoAction('debtInfo'))
    }, [dispatch])

    const handleAddDebtInfo = () => {
        history.push(`/${i18n.language}${t('routes.vehicle_tax_debt')}`)
        // const newDebtInfo = validateForm();
        // if (newDebtInfo) {
        //     dispatch(listAddAction("debtInfo", newDebtInfo));
        //     dispatch(clearListInfoAction('debtInfo'))
        // }
    }

    return (
        <>
            <div className="row">
                <div className="col-xs-12 col-md-8">
                    <h2>{t('debt_info_list.or_add_another')}</h2>
                </div>
            </div>
            {/* <DebtInformationForm
                editDebtInfoId={false}
                setValidateForm={setValidateForm}
                setIsError={setIsError}
            /> */}
            <div className="row">
                <div className="col-xs-12 col-lg-8">
                    <button
                        className="btn-lg btn-default"
                        onClick={handleAddDebtInfo}
                        value={t('debt_info_list.add_debt_info')}
                        name={t('debt_info_list.add_debt_info')}
                    >
                        {t('debt_info_list.add_debt_info')}
                    </button>
                </div>
            </div>
        </>
    )
}

export default withTranslation('common')(AddDebtInformationView)
